module.exports = __webpack_public_path__ + "static/media/ring-line-3-top.f89582e7.svg";